import { render } from "./IpRangesTabManagement.vue?vue&type=template&id=2764a929&scoped=true"
import script from "./IpRangesTabManagement.vue?vue&type=script&lang=js"
export * from "./IpRangesTabManagement.vue?vue&type=script&lang=js"

import "./IpRangesTabManagement.vue?vue&type=style&index=0&id=2764a929&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2764a929"]])

export default __exports__